export enum OperatorMessages {
    ADDED = "Pomyślnie dodano operatora",
    EDITED = "Pomyślnie edytowano operatora"
}